export default __webpack_public_path__ + "sounds/applauseshort.mp3";